<div class="stage" *ngIf="!!view.stage" [innerHTML]="view.stage"></div>